import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { usePartnerRadios } from '../hooks/usePartnerRadios';
import './PartnerRadiosPage.css';

const PartnerRadiosPage: React.FC = () => {
  const { radios, loading, error } = usePartnerRadios();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const placeholderLogo =
    'https://via.placeholder.com/220x220/FFD700/000?text=Radio';

  return (
    <div className="partner-radios-container">
      <div className="partner-radios-page-wrapper">
        <div className="partner-radios-header">
          <h1>Rádios Parceiras</h1>
          <p>Ouça as emissões online em um clique</p>
        </div>

        {loading ? (
          <div className="partner-radios-loading">
            <div className="spinner" />
            <p>A carregar rádios...</p>
          </div>
        ) : error ? (
          <div className="partner-radios-error">
            <h2>Erro ao carregar rádios</h2>
            <p>{error}</p>
          </div>
        ) : radios.length === 0 ? (
          <div className="partner-radios-empty">
            <h3>Nenhuma rádio encontrada</h3>
            <p>Adicione documentos na coleção <code>parcerias</code> do Firebase.</p>
          </div>
        ) : (
          <div className="partner-radios-grid">
            {radios.map((radio) => (
              <div key={radio.id} className="partner-radio-card">
                <div className="partner-radio-logo">
                  <img
                    src={radio.logo || placeholderLogo}
                    alt={radio.name || radio.id}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = placeholderLogo;
                    }}
                  />
                </div>

                {radio.name && <h3 className="partner-radio-name">{radio.name}</h3>}

                <a
                  className="partner-radio-listen-btn btn-primary"
                  href={radio.link || '#'}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Ouvir ${radio.name || radio.id}`}
                  onClick={(e) => {
                    if (!radio.link) e.preventDefault();
                  }}
                >
                  Ouvir Rádio
                </a>

                <Link
                  className="partner-radio-interviews-btn btn-primary"
                  to={`/radios/${radio.id}/entrevistas`}
                  aria-label={`Ver entrevistas de ${radio.name || radio.id}`}
                >
                  Ver Entrevistas
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PartnerRadiosPage;

